import React, { useEffect, useState } from 'react';
import { Carousel} from 'react-bootstrap';
import './Banner.css'



const Banner = () => {

    return (
        <div >
          <Carousel>


<Carousel.Item  vinterval={10000}>
   <img
     className="d-block w-100 rounded-3"
   src="https://i.ibb.co/LS9LjQb/ban-1.jpg" 
     alt="First slide"
   />
   <Carousel.Caption>
     <h3 className='b-title'>Best Online Teacher</h3>
     <p className='b-body
     '>I am well known to our all digital education platfrom. If You find a online tutor, You can Hire Me...</p>
     <a className="b-link" href="https://dhananjoychandradas.blogspot.com/" target="_blank" > Hire me as Online Tutor</a>
   </Carousel.Caption>
 </Carousel.Item>

<Carousel.Item interval={10000}>
   <img
     className="d-block w-100 rounded-3"
   src="https://i.ibb.co/fFM2SJS/ban-3.jpg"  
     alt="First slide"
   />
   <Carousel.Caption>
     <h3 className='b-title'>Friendly with Student</h3>
     <p className='b-body
     '>If you find a friendly tutor For you, I am the right person. So, No need to go other places. just clicking the button below...</p>
     <a className="b-link" href="https://dhananjoychandradas.blogspot.com/" target="_blank" > Hire me as Friendly Tutor </a>
   </Carousel.Caption>
 </Carousel.Item>
<Carousel.Item interval={8000}>
   <img
     className="d-block w-100 rounded-3"
   src="https://i.ibb.co/xJzTNj3/ban-2.jpg" 
     alt="First slide"
   />
   <Carousel.Caption>
     <h3 className='b-title'>Teaching with Example Practically</h3>
     <p className='b-body
     '>A practical Example can make a topic easy. I am expert to show practical example in related topics. Just Clicking below... </p>
     <a className="b-link" href="https://dhananjoychandradas.blogspot.com/" target="_blank" > Hire me for learning Practically </a>
   </Carousel.Caption>
 </Carousel.Item>


</Carousel>
        </div>
    );
};

export default Banner;